import axiosInstance from "@/config/axios";

import type { CreateSOEType } from "@/modules/admin/types/soe";

const getSOEs = async (params?: { [key: string]: string | number }) => {
	const response = await axiosInstance.get("/auth/sign-in-company", { params });
	return response.data;
};

export const getSubSOEs = async (params?: {
	[key: string]: string | number;
}) => {
	const response = await axiosInstance.get("/companies/children", { params });
	return response.data;
};

const getSOE = async (id: string) => {
	console.log("id:::::::::::::", id);
	const response = await axiosInstance.get(`/companies/${id}`);
	return response.data;
};
export const getLandAssets = async (params?: {
	[key: string]: string | number;
}) => {
	const response = await axiosInstance.get("/land-assets", { params });
	return response.data;
};
export const getCompanyDepartment = async (params?: {
	[key: string]: string | number;
}) => {
	const response = await axiosInstance.get("/company-dept", { params });
	return response.data;
};

export const getCompanyDepartmentDetail = async (id: string) => {
	const response = await axiosInstance.get(`/company-dept/${id}`);
	return response.data;
};

export const createCompanyDepartment = async (data: {
	[key: string]: string | number;
}) => {
	const response = await axiosInstance.post("/company-dept", data);
	return response.data;
};

export const updateCompanyDepartment = async (
	id: string | undefined,
	data: { [key: string]: string | number },
) => {
	const response = await axiosInstance.put(`/company-dept/${id}`, data);
	return response.data;
};
const createSOE = async (data: CreateSOEType) => {
	console.log(data, "Create Admin");

	// const response = await axiosInstance.post("/Admins", Admin);
	// return response.data;
};
export const createLandAsset = async (data: {
	[key: string]: string | number;
}) => {
	if (data.govFunded === undefined) {
		data.govFunded = 0;
	}
	const response = await axiosInstance.post("/land-assets", data);
	return response.data;
};

export const updateLandAsset = async (
	id: string | undefined,
	data: { [key: string]: string | number },
) => {
	const response = await axiosInstance.put(`/land-assets/${id}`, data);
	return response.data;
};

export const createCompanyShareholder = async (data: {
	[key: string]: string | number | boolean;
}) => {
	const response = await axiosInstance.post("/boards", data);
	return response.data;
};
export const updateCompanyShareholder = async (
	id: string | undefined,
	data: { [key: string]: string | number | boolean },
) => {
	const response = await axiosInstance.put(`/boards/${id}`, data);
	return response.data;
};
export const getCompanyShareholders = async (params?: {
	[key: string]: string | number;
}) => {
	const response = await axiosInstance.get("/boards", {
		params,
	});
	return response.data;
};
const updateSOE = async (id: string | undefined, data: unknown) => {
	console.log(id, data, "Update Admin");
	const response = await axiosInstance.put(`/companies/${id}`, data);
	return response.data;
};
const deleteSOE = async (id: string) => {
	console.log(id, "Delete Admin");
	// const response = await axiosInstance.delete(`/Admins/${id}`);
	// return response.data;
};
import type { MutateSOE } from "@/types/soe";
export const createSubSOE = async (data: MutateSOE) => {
	const response = await axiosInstance.post("/companies/child", data);
	return response.data;
};
export const getCompanyDirectors = async (params?: {
	[key: string]: string | number;
}) => {
	const response = await axiosInstance.get("/directors", {
		params,
	});
	return response.data;
};
export const createCompanyDirector = async (data: {
	[key: string]: string | number | boolean;
}) => {
	const response = await axiosInstance.post("/directors", data);
	return response.data;
};
export const updateCompanyDirector = async (
	id: string | undefined,
	data: { [key: string]: string | number | boolean },
) => {
	const response = await axiosInstance.put(`/directors/${id}`, data);
	return response.data;
};
export const deleteCompanyDirector = async (id: string) => {
	const response = await axiosInstance.delete(`/directors/${id}`);
	return response.data;
};

export const getSecretariat = async (params: {
	[key: string]: string | number;
}) => {
	const response = await axiosInstance.get("/secretariats", {
		params,
	});
	return response.data;
};

export const createSecretariat = async (data: {
	[key: string]: string | number;
}) => {
	const response = await axiosInstance.post("/secretariats", data);
	return response.data;
};

export const updateSecretariat = async (
	id: string | undefined,
	data: { [key: string]: string | number },
) => {
	const response = await axiosInstance.put(`/secretariats/${id}`, data);
	return response.data;
};

export const deleteSecretariat = async (id: string) => {
	const response = await axiosInstance.delete(`/secretariats/${id}`);
	return response.data;
};
// Employee : ພະນັກງານ / ຂໍ້ມູນບັນຊີເຂົ້າລະບົບ
export const getEmployee = async (params?: {
	[key: string]: string | number;
}) => {
	const response = await axiosInstance.get("/employees", {
		params,
	});
	return response.data;
};

export const createEmployee = async (data: {
	[key: string]: string | number;
}) => {
	const response = await axiosInstance.post("/employees", data);
	return response.data;
};

export const updateEmployee = async (
	id: string | undefined,
	data: { [key: string]: string | number },
) => {
	const response = await axiosInstance.put(`/employees/${id}`, data);
	return response.data;
};

export const updateEmployeeStatus = async (
	id: string,
	data: { statusId: string },
) => {
	const response = await axiosInstance.put(`/employees/${id}/status`, data);
	return response.data;
};

export { getSOEs, getSOE, createSOE, updateSOE, deleteSOE };
